module.exports = __webpack_public_path__ + "img/DataCollect.aca72233.svg";